/**
 * Capabilities POS alignées sur backend/middleware/staffRoleCapabilities.js (POS-PERM-1).
 * L'API reste l'autorité ; ce module sert uniquement à masquer les actions interdites.
 */

const ROLE_CAPABILITIES = {
  GERANT: [
    'caisse', 'caisse:session', 'caisse:session:force', 'caisse:tresorerie', 'caisse:remboursement',
    'caisse:kpi', 'caisse:postes', 'caisse:fiscal', 'caisse:fiscal:read', 'caisse:stock-sync',
    'caisse:restaurant:ops', 'caisse:restaurant:admin', 'caisse:restaurant:kitchen',
  ],
  MANAGER: [
    'caisse', 'caisse:session', 'caisse:session:force', 'caisse:tresorerie', 'caisse:remboursement',
    'caisse:kpi', 'caisse:postes', 'caisse:fiscal', 'caisse:fiscal:read', 'caisse:stock-sync',
    'caisse:restaurant:ops', 'caisse:restaurant:admin', 'caisse:restaurant:kitchen',
  ],
  VENDEUR: ['caisse', 'caisse:restaurant:ops'],
  CAISSIER: ['caisse'],
  SERVEUR: ['caisse', 'caisse:restaurant:ops'],
};

function normalizeEmail(email) {
  return String(email || '').trim().toLowerCase();
}

/**
 * @param {object|null} user — admin_user (roleInterne, email, commercant)
 * @returns {string[]} capabilities
 */
export function resolvePosStaffCapabilities(user) {
  if (!user || user.role === 'SUPER_ADMIN' || user.role === 'ADMIN') {
    return ROLE_CAPABILITIES.GERANT;
  }
  const roleInterne = user.roleInterne || null;
  if (roleInterne && ROLE_CAPABILITIES[roleInterne]) {
    return ROLE_CAPABILITIES[roleInterne];
  }
  const shopEmail = normalizeEmail(user.commercant?.email);
  const userEmail = normalizeEmail(user.email);
  // Legacy UI : email boutique seul — l’API applique la qualification complète (équipe migrée).
  if (!roleInterne && shopEmail && userEmail && shopEmail === userEmail) {
    return ROLE_CAPABILITIES.GERANT;
  }
  return [];
}

export function canPosAction(user, capability) {
  return resolvePosStaffCapabilities(user).includes(capability);
}

export function getAdminUserFromStorage() {
  try {
    return JSON.parse(localStorage.getItem('admin_user') || '{}');
  } catch {
    return {};
  }
}
